export default __webpack_public_path__ + "static/media/history.d33906f3.svg";